import React from 'react';
import { Tag } from 'antd';
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  ExclamationCircleOutlined,
  StopOutlined
} from '@ant-design/icons';

interface SubscriptionStatusBadgeProps {
  status: 'active' | 'expired' | 'trial' | 'suspended' | string;
  size?: 'small' | 'default';
}

const SubscriptionStatusBadge: React.FC<SubscriptionStatusBadgeProps> = ({ 
  status, 
  size = 'default' 
}) => {
  const getStatusConfig = (status: string) => {
    switch (status.toLowerCase()) {
      case 'active':
        return {
          color: 'success',
          icon: <CheckCircleOutlined />,
          text: 'Actif'
        };
      case 'trial':
        return {
          color: 'processing',
          icon: <ClockCircleOutlined />,
          text: 'Essai'
        };
      case 'expired':
        return {
          color: 'error',
          icon: <ExclamationCircleOutlined />,
          text: 'Expiré'
        };
      case 'suspended':
        return {
          color: 'warning',
          icon: <StopOutlined />,
          text: 'Suspendu'
        };
      default:
        return {
          color: 'default',
          icon: null,
          text: 'Inconnu'
        };
    }
  };

  const config = getStatusConfig(status);

  return (
    <Tag 
      color={config.color} 
      icon={config.icon}
      className={size === 'small' ? 'text-xs' : ''}
    >
      {config.text}
    </Tag>
  );
};

export default SubscriptionStatusBadge;